import React from 'react';

interface ImageModalProps {
  src: string;
  alt: string;
  onClose: () => void;
}

const ImageModal: React.FC<ImageModalProps> = ({ src, alt, onClose }) => {
  const handleOutsideClick = (event: React.MouseEvent<HTMLDivElement>) => {
    // Close only if the click is outside the image
    if (event.target === event.currentTarget) {
      onClose();
    }
  };

  return (
    <div
      className='fixed inset-0 bg-white/50 flex items-center justify-center z-50'
      onClick={handleOutsideClick}
    >
      <div className='relative bg-white p-4 rounded-lg shadow-lg max-w-[90vw] max-h-[90vh]'>
        <button
          className='absolute top-2 right-2 text-gray-600 hover:text-black text-2xl'
          onClick={onClose}
        >
          &times;
        </button>
        <img
          src={src}
          alt={alt}
          className='max-w-full max-h-[80vh] rounded-md'
        />
      </div>
    </div>
  );
};

export default ImageModal;
